// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1NMwG","ranges":"BmiRanges_ranges__x_Q5T"};